import React, { useId } from "react";

/**
 * Accessible toggle switch.
 * Props: checked, onChange, disabled, label (for aria)
 */
export default function ToggleSwitch({ checked, onChange, disabled = false, label }) {
  const id = useId();

  return (
    <label
      className={`cb-toggle ${disabled ? "cb-toggle-disabled" : ""}`}
      htmlFor={id}
      aria-label={label}
      title={disabled ? "Always enabled — required for site functionality" : undefined}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={disabled ? undefined : onChange}
        disabled={disabled}
        aria-checked={checked}
        role="switch"
      />
      <span className="cb-toggle-track" />
      <span className="cb-toggle-thumb" />
    </label>
  );
}
